module.exports = __webpack_public_path__ + "img/media (11).a20e3b53.png";